<div id="welcome">
  
  <div id="welcome_container">
    <h1>A knowledge based <br />protein/gene data platform</h1>
    <p>open repository of protein synonym and protein interaction knowledge graph</p>
  </div>

</div>


<!--

<div class="division"></div>

<div id="knowledge_graph" class="class-container" >
  <nz-carousel nzAutoPlay>
    <div nz-carousel-content *ngFor="let graph of knowledgeGraph; index as carouselId" [style]="'background-image: url(' + graph.img + ')'">
      <div class="carousel-title">
        <h3>{{ graph.name }}</h3>
        <div nz-row nzJustify="end">
          <div *ngFor="let feature of graph.feature" nz-col nzSpan="12">
            {{ feature }}
          </div>
        </div>
        <button [routerLink]="graph.routerUrl" nz-button nzType="primary" nzSize="large" nzShape="round"><i nz-icon nzType="login" nzTheme="outline"></i>Enter</button>
      </div>
    </div>
  </nz-carousel>
</div>
-->